// Copyright (c) Ensho Health, 2022 to present

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Return the result list filters formatted as arrays instead of objects
 * One use of this function is to prepare the GQL variables for the backend
 */
export function formatFilters(filters) {
  const res = {
    labs: null,
    normal: null,
    abnormal: null,
    notComputable: null,
    dateStart: null,
    orderingPhyId: null,
    dateEnd: null
  };

  if (filters.algo?.value) {
    res.labs = [filters.algo.value];
  }

  switch (filters.outcome?.value) {
    case 'normal':
      res.normal = true;
      res.notComputable = false;
      break;
    case 'abnormal':
      res.abnormal = true;
      res.notComputable = false;
      break;
    case 'notComputable':
      res.notComputable = true;
      break;
    default:
      break;
  }

  res.orderingPhyId = filters.orderingPhy?.physicianId;

  const startOfDay = dayjs().tz('America/Toronto').startOf('day');
  switch (filters.timeFrame?.value) {
    case 'Past week':
      res.dateStart = startOfDay.subtract(1, 'week').unix();
      break;
    case 'Past month':
      res.dateStart = startOfDay.subtract(1, 'month').unix();
      break;
    case 'Past 3 months':
      res.dateStart = startOfDay.subtract(3, 'month').unix();
      break;
    case 'Past 6 months':
      res.dateStart = startOfDay.subtract(6, 'month').unix();
      break;
    case 'Past 12 months':
      res.dateStart = startOfDay.subtract(1, 'year').unix();
      break;
    case 'Custom':
      res.dateStart = dayjs(filters.date.start)
        .tz('America/Toronto')
        .startOf('day')
        .unix();
      res.dateEnd = dayjs(filters.date.end)
        .tz('America/Toronto')
        .endOf('day')
        .unix();
      break;
    default:
      break;
  }
  if (res.dateStart && !res.dateEnd) {
    res.dateEnd = dayjs().tz('America/Toronto').endOf('day').unix();
  }
  return res;
}
